import cn from "classnames";
import { ComboBox as TrussComboBox } from "@trussworks/react-uswds";

import styles from "./ComboBox.module.scss";

type ComboBoxProps = {
  label?: React.ReactNode;
  rootClassname?: string;
  comboboxClassname?: string;
} & React.ComponentProps<typeof TrussComboBox>;

/**
 * A USWDS ComboBox component with some additional styling.
 *
 * @prop {React.ReactNode} [label] - An optional label for the combobox.
 * @prop {string} [rootClassname] - An optional class name for the outermost element.
 * @prop {string} [comboboxClassname] - An optional class name for the Trussworks `ComboBox` element.
 * @prop {React.ComponentProps<typeof TrussComboBox>} - Other props are forwarded to the Trussworks`ComboBox` component.
 *
 * @example
 * <ComboBox
 *   label="State"
 *   id="state"
 *   name="state"
 *   options={usStates}
 *   defaultValue="California"
 * />
 */
export default function ComboBox(props: ComboBoxProps) {
  const { label, rootClassname, comboboxClassname, ...rest } = props;

  const rootClasses = cn(styles["combo-box-root"], {
    [rootClassname!]: rootClassname,
  });

  const comboboxClasses = cn(styles["combo-box"], {
    [comboboxClassname!]: comboboxClassname,
  });

  return (
    <div className={rootClasses}>
      {label && (
        <label htmlFor={props.id} className={styles["label"]}>
          {label}
        </label>
      )}

      <div className={styles["combo-box-wrapper"]}>
        <TrussComboBox className={comboboxClasses} {...rest} />
      </div>
    </div>
  );
}
